import { call, put, select } from "redux-saga/effects";
import { RegistererState } from "sip.js";
import { incReconnectionAttempt, selectRegisterer } from "../../../state/userAgent/userAgentSlice";
import { addRegistrarSaga } from "../addRegistrar/addRegistrar";
import { attemptReconnectAction } from "../attemptReconnect/action";

export function* onConnectSaga() {
  const registerer = yield select(selectRegisterer);
  const validState = [RegistererState.Initial, RegistererState.Unregistered];
  if (registerer && validState.includes(registerer.state) && !registerer.disposed) {
    try {
      yield registerer?.register({
        requestDelegate: {
          onReject(response) {
            console.debug('register onReject:', response);
            if (response.message.statusCode === 503 || response.message.statusCode === 500) {
              store.dispatch(incReconnectionAttempt());
            }
          },
        },
      });
    } catch (e) {
      if (e) {
        console.error(e);
        console.log('We hit attemptReconnect from onConnect', Date.now())
        yield put(attemptReconnectAction());
      }
    }
  } else {
    yield call(addRegistrarSaga);
  }

}